import React from 'react'

import { palette } from '@centivo/react-components'
import styled, { css } from 'styled-components'

const ButtonWrapper = styled.button<{ isActive?: boolean }>`
  width: 2.5rem;
  height: 2.5rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &::before,
  &::after,
  & div {
    background: ${palette.brand.teal};
    content: '';
    display: block;
    height: 0.375rem;
    border-radius: 0.1875rem;
    transition: 0.5s;
  }

  &::before,
  & div {
    margin-bottom: 0.5rem;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      &::before {
        transform: translateY(0.75rem) rotate(135deg);
      }

      &::after {
        transform: translateY(-0.75rem) rotate(-135deg);
      }

      & div {
        transform: scale(0);
      }
    `}
`

interface BurgerMenuProps extends React.ComponentPropsWithRef<'button'> {
  isActive?: boolean
}

export const BurgerMenu: React.FC<BurgerMenuProps> = React.forwardRef(
  (props, ref) => (
    <ButtonWrapper ref={ref} {...props}>
      <div />
    </ButtonWrapper>
  )
)

BurgerMenu.displayName = 'BurgerMenu'
